<span class="button-title-label">{{ dropdownTitle }}</span>
<button mat-icon-button [matMenuTriggerFor]="menu">
  <mat-icon svgIcon="expand"></mat-icon>
</button>
<mat-menu #menu="matMenu" class="large-mat-menu {{ matMenuClass }}">
  <div class="radio-container">
    <div class="item-row" *ngFor="let item of dropdownItems; let isLast = last">
      <div *ngIf="!isLast" class="vertical-line"></div>
      <mat-radio-button
        [checked]="item.active"
        [disabled]="!item.url"
        (change)="navigate(item.url!)"
        >{{ item.label }}</mat-radio-button
      >
      <ng-container *ngIf="item.extraContent">
        <ng-container *ngTemplateOutlet="item.extraContent"></ng-container>
      </ng-container>
    </div>
  </div>
  <ng-content></ng-content>
</mat-menu>
